import { render } from "./TrameEleve.vue?vue&type=template&id=70952325&scoped=true"
import script from "./TrameEleve.vue?vue&type=script&lang=js"
export * from "./TrameEleve.vue?vue&type=script&lang=js"

import "./TrameEleve.vue?vue&type=style&index=0&id=70952325&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70952325"]])

export default __exports__